import { useEffect } from 'react';
import { useCalculateLmsCreateRequestEndDateMutation } from '../../../../api';

const toDate = (value) => (value ? new Date(value) : null);

// Formda anlık bitiş tarihi önizlemesi — bkz. docs/LMS-Sure-Bitis-Tarihi-FE-Notu.txt §2.
// Kayıt oluşturmaz; sonuç formData.trainingEndDate / alternativeEndDate'e yazılır.
// Tarih parametreleri API formatında (string) beklenir.
const useEndDatePreview = ({ enabled, preferTrainingDate, alternativeDate, trainingDayCount, setFormData }) => {
    const [calculateEndDate, { isLoading }] = useCalculateLmsCreateRequestEndDateMutation();

    useEffect(() => {
        if (!enabled) return undefined;

        const timer = setTimeout(() => {
            if (trainingDayCount == null || trainingDayCount === '') {
                setFormData((prev) => ({ ...prev, trainingEndDate: null, alternativeEndDate: null }));
                return;
            }

            calculateEndDate({ preferTrainingDate, alternativeDate, trainingDayCount: Number(trainingDayCount) })
                .unwrap()
                .then((result) => setFormData((prev) => ({ ...prev, trainingEndDate: toDate(result?.trainingEndDate), alternativeEndDate: toDate(result?.alternativeEndDate) })))
                .catch(() => {
                    // Önizleme hatası kaydı engellemez, eski değerler korunur.
                });
        }, 500);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, preferTrainingDate, alternativeDate, trainingDayCount]);

    return isLoading;
};

export default useEndDatePreview;
